<div
  *ngFor="let chart of chartNames"
  [ngClass]="{ 'expand-div': chart == 'expand' }"
>
  <button
    *ngIf="chart != 'expand'"
    data-id="ChartSelectButton.Metric.{{ metricId }}"
    (click)="selectChart(chart)"
    (mouseover)="highlightChart(chart)"
    (mouseout)="unHighlightChart(chart)"
    (focus)="highlightChart(chart)"
    class="btn btn-link view-select-btns"
    [disabled]="disableBtns"
    [ngClass]="{ 'no-click-btns': disableBtns }"
  >
    <img
      *ngIf="chart == 'overall'"
      [src]="getFullImagePath('number_icon', chart)"
      class="btn-image"
      alt="Overall results"
      title="Overall results"
    />

    <img
      *ngIf="chart == 'category'"
      [src]="getFullImagePath('stacked_bar_chart_icon', chart)"
      class="btn-image"
      alt="Part-to-whole chart shows differences in size of performance level groups"
      title="Performance levels"
    />

    <img
      *ngIf="chart == 'trend'"
      [src]="getFullImagePath('line_chart_icon', chart)"
      class="btn-image"
      alt="Trendline chart shows changes over time"
      title="Trendline"
    />

    <img
      *ngIf="chart == 'characteristic'"
      [src]="getFullImagePath('horizontal_bar_chart_icon', chart)"
      class="btn-image"
      alt="Bar chart shows variation within demographic groups"
      title="Demographics"
    />

    <img
      *ngIf="chart == 'topBottomRank'"
      [src]="getFullImagePath('rank_list_icon', chart)"
      class="btn-image"
      alt="List of highest and lowest five results by school"
      title="School Rankings"
    />

    <img
      *ngIf="chart == 'calendar'"
      [src]="getFullImagePath('calendar_icon', chart)"
      class="btn-image calendar-image"
      alt="Calendar chart shows day-by-day results"
      title="Calendar"
    />

    <img
      *ngIf="chart == 'otherReports'"
      [src]="getFullImagePath('other_reports', chart)"
      class="btn-image"
      alt="Go to other reports"
      title="Other reports"
    />
  </button>
  <!-- Metric Zoom: Explore button -->
  <button
    mat-raised-button
    class="metric-zoom-explore-button"
    color="secondary"
    data-id="ChartSelectButton.Metric.{{ metricId }}"
    (click)="selectChart(chart)"
    (mouseover)="highlightChart(chart)"
    (mouseout)="unHighlightChart(chart)"
    (focus)="highlightChart(chart)"
    [disabled]="disableBtns"
    [ngClass]="{ 'no-click-btns': disableBtns }"
    *ngIf="chart == 'expand' && domainId != 1005"
  >
    Explore
  </button>
</div>
